"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOB_TYPES_NL = void 0;
/**
 * Job types
 */
exports.JOB_TYPES_NL = {
    INSTALLATION: 'Installatie',
    PTC: 'Schouw',
};
